import { render } from "./LocalFilePicker.vue?vue&type=template&id=baa433a4"
import script from "./LocalFilePicker.vue?vue&type=script&lang=js"
export * from "./LocalFilePicker.vue?vue&type=script&lang=js"

import "./LocalFilePicker.vue?vue&type=style&index=0&id=baa433a4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__